/**
 * Constants Module - Central export for all constants
 *
 * IMPORTANT: Most constants are now auto-generated!
 * See generated.ts for the auto-generated constants from backend
 */

// Import everything from generated file
import * as generated from './generated';

// Re-export most things from generated file (excluding what we'll transform)
export {
  DEFAULT_VALUES,
  TTS_PROVIDERS,
  STT_PROVIDERS,
  LLM_MODELS,
  LANGUAGES,
  RESOLUTIONS,
  VIDEO_STYLES,
  DURATION_OPTIONS,
  VOICE_OPTIONS,
  TTS_VOICES,
  TTS_LANGUAGE_SUPPORT,
  getVoicesForLanguageAndProvider,
  getDefaultVoiceForLanguageAndProvider,
  isRealServerlessEnvironment,
  transformLlmProviders,
  transformLlmModels,
  // Backend constants
  DEFAULT_PROVIDER,
  TTS_PROVIDERS_CHOICES,
  TTS_LANGUAGE_PROVIDER_MAP,
} from './generated';

// Export type definitions
export type { VoiceOption, Language, TTSProvider, STTProvider, SelectOption } from './generated';

// Apply transformations for dynamic values
// Using a getter to ensure real-time evaluation based on current environment
// Defensive check: ensure LLM_PROVIDERS is an array before transforming
export const LLM_PROVIDERS = generated.transformLlmProviders(
  Array.isArray(generated.LLM_PROVIDERS) ? generated.LLM_PROVIDERS : []
);

// Video source constants (stock vs AI-generated)
export * from './videoSources';

// Kling AI video generation constants
export * from './klingVideo';

// Wan 2.1 local video generation constants (FREE!)
export * as Wan21 from './wan21';

// LTX-2 local video generation constants (FREE, ultra-fast!)
export * as LTX2 from './ltx2';

// AnimateDiff local video generation constants (FREE, adds motion to images!)
export * as AnimateDiff from './animatediff';

// Timing constants (polling, retries, cache TTL, timeouts)
export * from './timings';

// File size constants and utilities
export * from './fileSize';

// Centralized error messages
export * from './errorMessages';

// Talking Heads provider constants (InfiniteTalk, MuseTalk, LatentSync, Wav2Lip)
export * from './talkingHeads';
